import { useState, useEffect, useRef, useCallback } from "react";
import "./HeroSlider.css";

const slides = [
  {
    backgroundImage: "/images/slide1.png",
    logo: "/images/logo2.png",
    subtitle: "Elevate Your Brand",
    description: "With Packaging Solutions",
  },
  { backgroundImage: "/images/slide3.png" },
  { backgroundImage: "/images/slide6.png" },
  { backgroundImage: "/images/slide5.png" },
];

function HeroSlider() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const touchStartX = useRef(null);

  // Function to change slide
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, []);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  // Swipe gesture for mobile
  useEffect(() => {
    const handleTouchStart = (e) => {
      touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
      const touchEndX = e.changedTouches[0].clientX;
      if (touchStartX.current - touchEndX > 50) {
        nextSlide();
      } else if (touchStartX.current - touchEndX < -50) {
        prevSlide();
      }
    };

    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [nextSlide]);

  return (
    <div className="hero-slider">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`slide ${index === currentSlide ? "active" : ""}`}
          style={{ backgroundImage: `url(${slide.backgroundImage})` }}
        >
          <div className="slide-content">
            {slide.logo && (
              <div className="logo-container">
                <img src={slide.logo} alt="Company Logo" className="company-logo" />
              </div>
            )}

            <div className="text-content">
              {slide.subtitle && <h1>{slide.subtitle}</h1>}
              {slide.description && <p>{slide.description}</p>}
            </div>
          </div>
        </div>
      ))}

      <button className="nav-button prev" onClick={prevSlide}>&#8249;</button>
      <button className="nav-button next" onClick={nextSlide}>&#8250;</button>

      <div className="slider-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default HeroSlider;
